/*
 * Want to add more shared files? go/generator-shared
 */
import Constants from './constants/';
import Services from './services/';
import Filters from './filters/';

export default angular.module('searchEngineFrontend.app.shared', [
  Constants.name,
  Services.name,
  Filters.name
]);



// WEBPACK FOOTER //
// ./src/app/shared/index.js